import axios from "axios";
import { getCSRFToken } from "../auth/Authenticate";

export const SearchAPI = (query: any, onSuccess: any, onError: any) => {
  axios
    .get(
      `${process.env.REACT_APP_API_URL}/v1/public/photos/search?q=${query}`,
      {
        withCredentials: true,
        headers: {
          "x-csrf-token": getCSRFToken(),
        },
      }
    )
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onError(error);
    });
};

export const SearchTagsAPI = (query: any, onSuccess: any, onError: any) => {
  axios
    .get(
      `${process.env.REACT_APP_API_URL}/v1/public/photos/search_tags?q=${query}`,
      {
        withCredentials: true,
        headers: {
          "x-csrf-token": getCSRFToken(),
        },
      }
    )
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onError(error);
    });
};
